import axios from "axios";
import CommonApi from "./CommonApi";


export default class ConstructionSiteApi {
    static async getAllWorksTypes(){
        const res=await axios.get( CommonApi.getHost()+"/ConstructionSite/getWorks")
        return res.data;
    }
    static async getAllProgressWorkTypes(){
        const res=await axios.get(CommonApi.getHost()+"/ConstructionSite/getProgressWorks")
        return res.data;
    }
    static async addImage(image, house, floor){

        const FormData=new window.FormData();

        FormData.append('image', image,'1.jpg')
        FormData.append('house', house)
        FormData.append('floor', floor)
        const res=await axios.post( CommonApi.getHost()+"/ToDo/addImage",  FormData)
        return res.data;
    }
}